import network from '@/services/network';
import { ErrorResponse } from '@/utils';

export interface VersionResponse {
  /**
   * Git-HEAD des laufenden Deploys; null auf Hosts ohne SENTRY_RELEASE.
   * Diagnose-/Smoke-Wert — fuer den Versions-Check bewusst NICHT verwendet,
   * siehe `fe_build`.
   */
  build: string | null;
  /**
   * Version des ausgelieferten FE-Bundles, vom Deploy beim FE-Swap gestempelt.
   * NUR dieser Wert wird gegen den einkompilierten Stand verglichen: der
   * Git-HEAD wandert auch bei BE-only-Deploys weiter und meldete dann eine
   * Abweichung, die es nicht gibt (Dauer-Banner nach #101).
   */
  fe_build: string | null;
}

const getVersion = async (): Promise<VersionResponse> => {
  try {
    const { data } = await network.get<VersionResponse>('/version');
    return data;
  } catch (error) {
    throw new ErrorResponse(error);
  }
};

export default { getVersion };
